import Vue from 'vue';

/**
 * Whether the last API response carried `X-Verification-Reminder: 1`.
 *
 * Django sets that header for a logged-in, non-staff user who has not finished
 * verifying or accepting *and* is still inside the 30-day grace window. It is a
 * nudge, not a state: it stops arriving once the user completes both, and also
 * once the window closes and the refusal takes over. So the flag is written on
 * every response, cleared included - the banner then turns itself off on the
 * first request after the user verifies, with no extra fetch.
 *
 * It lives here rather than in Vuex because `ApplicationRecord`'s middleware is
 * what sets it, and importing the store from the API layer would close an
 * import cycle (`store/Auth` already imports `@/api`).
 *
 * **Nothing reads it at the moment.** `VerificationAlert` was its only consumer
 * and P4-08 merged that into `AccountNoticesAlert`, which is driven off the user
 * resource instead - `isVerified` and `termsAcceptanceRequired` say everything
 * the header says apart from "the window is still open", and unlike the header
 * they are not absent for staff. Kept, and still written on every response,
 * because it is the only signal the SPA gets about the grace window at all: if
 * the notices page ever names a deadline, this is where that starts.
 */
const state = Vue.observable({ active: false });

export function setVerificationReminder(active: boolean) {
  state.active = active;
}

export function verificationReminderActive(): boolean {
  return state.active;
}
